import * as React from 'react'
import { FunctionComponent } from 'react'
import TableContext, {
  createTableContext,
} from '../../../contexts/TableContext'
import { ReportGroupBy } from '../../../typings/report'
import TransactionsTable from './TransactionsTable'

import {
  TransactionDetailsReportingSorts,
  TransactionDetailsReportingQueryVariables,
  useTransactionDetailsReportingLazyQuery,
} from '../../../generated/types'

type TransactionsSorts = 'clickId' | 'clickAt' | 'campaign' | 'page'

type GroupBy = { [key in ReportGroupBy]: string }

interface TransactionsFilters extends GroupBy {
  dateType: string
  dateRange: string
  startDate: string
  endDate: string
  vertical: string
  productType: string
  program: string
  product: string
  campaign: string
  event: string
  clickedProduct: string
  subTracking: string
}

export type TransactionDetailsReportVariables = TransactionDetailsReportingQueryVariables

export type TransactionDetailsReportSorts = keyof TransactionDetailsReportingSorts

export const TransactionsTableContext = createTableContext<
  TransactionsFilters,
  TransactionsSorts
>()

const TransactionsReport: FunctionComponent = () => {
  const [
    TransactionDetailsReportingResult,
    { data, loading, error },
  ] = useTransactionDetailsReportingLazyQuery({
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
  })
  const [
    TransactionDetailsReportingExportResult,
    { data: exportData, loading: exportLoading, error: exportError },
  ] = useTransactionDetailsReportingLazyQuery({
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
  })
  return (
    <TableContext<TransactionsFilters, TransactionsSorts>
      Context={TransactionsTableContext}
      queryParams={[
        'dateRange',
        'startDate',
        'endDate',
        'vertical',
        'productType',
        'program',
        'product',
        'clickedProduct',
        'campaign',
        'dateType',
        'event',
        'subTracking',
      ]}
    >
      <TransactionsTable
        getData={TransactionDetailsReportingResult}
        data={data}
        loading={loading}
        error={error != null}
        getExportData={TransactionDetailsReportingExportResult}
        exportData={exportData}
        exportLoading={exportLoading}
        exportError={exportError != null}
      />
    </TableContext>
  )
}

export default TransactionsReport
